export function useOnClick(props) {
  return async function onClick() {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('customBeforePrint'))
    }
  }
}
